import axios from './axios';

const PublicService = {
    verifyEmployees: async (data) => {
        try {
            const response = await axios.post('/employees/verify', data);
            return response.data.data;
        } catch(error) {
            return error.response.data;
        }
    },
    createPassword: async (data) => {
        try {
            const response = await axios.post('/employees/create_password', data);
            return response.data.data;
        } catch(error) {
            return error.response.data;
        }
    },
};
export default PublicService